import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Col, Modal, Row } from "react-bootstrap";
import classes from "./LessonDetailModal.module.css";
import {
  CalendarIconGray,
  ClockIconGray,
  coachDemoImg,
  coachDemoImg2,
  LocationIconGray,
  starIconss,
  tableImg,
} from "../../../../constant/imagePath";
import StarRatings from "react-star-ratings";
import moment from "moment";
import {
  AiFillCalendar,
  AiFillClockCircle,
  AiOutlineLeft,
  AiOutlineRight,
} from "react-icons/ai";
import { BsChatDots } from "react-icons/bs";
import { MdPlace } from "react-icons/md";
import { ReactSVG } from "react-svg";

const LessonDetailModal = ({ show, setShow, data }) => {
  const [pagitnationSteps, setPagitnationSteps] = useState(1);

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"572px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
      // footer={true}
      >
        <div className={classes.modalContent}>
          <Row className="g-0">
            <Col md={12} className="d-flex">
              <div>
                <img
                  src={data?.userData?.photo}
                  className={`${[classes.profile].join(" ")}`}
                />
              </div>
              <div className={classes.headingWithRatingAndReviews}>
                <h5 className={classes.mainHeading}>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    {data?.userData?.displayName?.split(" ")[0]}
                  </span>
                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h5 }}
                  >
                    {data?.userData?.displayName?.split(" ")[1]}
                  </span>
                </h5>
                <div className={` ${[classes.userDetails].join(" ")}`}>
                  <p className={classes.ratingStar}>
                    <StarRatings
                      starRatedColor={Colors.mainShadeOfRed}
                      starEmptyColor={Colors.neutralShadesOfDimGray}
                      rating={data?.userData?.rating / 5}
                      starDimension={"16px"}
                      numberOfStars={1}
                    />
                  </p>

                  <span
                    className={`${[classes.rating].join(" ")}`}
                    style={{
                      color: Colors.neutralShadesOfNero,
                      ...Fonts.p2,
                      fontFamily: "inter-600",
                    }}
                  >
                    {data?.userData.rating?.toFixed(1)}
                  </span>

                  <p
                    style={{
                      ...Fonts.p2,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    (7 Reviews)
                  </p>

                  <span
                    className={`${[classes.break].join(" ")}`}
                    style={{
                      backgroundColor: Colors.neutralShadesOfPinkSwan,
                    }}
                  />

                  <span
                    style={{ color: Colors.neutralShadesOfNero, ...Fonts.h9 }}
                  >
                    {data?.userData.sport}
                  </span>
                </div>
              </div>
            </Col>
          </Row>

          <div className={classes.reviewCard}>
            <h1 style={{ ...Fonts.h5 }} className={classes.mb20}>
              Lesson details
            </h1>

            <div
              className={`${classes.dFlexAlignItemsCenter} ${classes.mb16}`}
            >
              <ReactSVG src={CalendarIconGray} className={classes.iconMarginRight} />
              <p>{moment(data?.dateItem?.date).format("MMMM DD, YYYY")}</p>
            </div>
            <div
              className={`${classes.dFlexAlignItemsCenter} ${classes.mb16}`}
            >
              <ReactSVG src={ClockIconGray} className={classes.iconMarginRight} />
              <p>{data?.timeItem?.time}</p>
            </div>
            <div
              className={`${classes.dFlexAlignItemsCenter} ${classes.mb32}`}
            >
              <ReactSVG src={LocationIconGray} className={classes.iconMarginRight} />
              <p>{data?.placeItem?.description}</p>
            </div>

            <h1
              style={{ ...Fonts.h5 }}
              className={`${classes.mb16}`}
            >
              Coach
            </h1>
            <div className={classes.tableImg}>
              <div className={classes.innerImgCont}>
                <img src={data?.coachData?.coachImg} alt="tableImg" />
              </div>
              <div>
                <h6
                  style={{
                    ...Fonts.h7,
                    color: Colors.neutralShadesOfNero,
                    lineHeight: '24px'
                  }}
                >
                  {data?.coachData?.coachName?.split(' ')[0]}
                </h6>
                <h6
                  style={{
                    ...Fonts.h7,
                    color: Colors.neutralShadesOfNero,
                    lineHeight: '24px'
                  }}
                >
                  {data?.coachData?.coachName?.split(' ')[1]}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default LessonDetailModal;

LessonDetailModal.defaultProps = {
  data: {
    dateItem: {
      icon: AiFillCalendar,
      date: "Mon Aug 16 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
    },
    timeItem: {
      icon: AiFillClockCircle,
      time: "12:30PM- 2:30PM",
    },
    placeItem: {
      icon: MdPlace,
      description: "DeWitt Clinton Park, W 54th St, New York, NY",
    },

    userData: {
      displayName: "Kate Johnson",
      photo: coachDemoImg2,
      rating: 5,
      sport: "Student",
      cancellation: "3",
      reviewTitle: "The coach did not show up for training.",
      reviewDescription:
        "The coach was 20 minutes late for training. When I reprimanded him, he was rude. In general, I am very dissatisfied with the student's behavior and ask him to be banned.",
    },

    coachData: {
      coachName: "Michael Baumgardner",
      coachImg: tableImg,
    },

    userDetailsCardsData: [
      {
        title: "Plans have changed.",
        description:
          "Unfortunately, I am having problems of a family nature. Because of this, I will not be able to attend the training",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Medical emergency",
        description:
          "Yesterday I broke my arm and spent the day in the hospital, so I could not cancel the class in advance.",
        timeAgo: "Within 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
      {
        title: "Other",
        description: "",
        timeAgo: "Before 24 hours",
        date: "Mon Jun 07 2021 05:00:00 GMT+0500 (Pakistan Standard Time)",
      },
    ],
  },
};
